import React from 'react';
import { motion } from 'framer-motion';
import { scrollToOffer } from '../utils/scroll';
import { Star, Zap, Shield, Lock, Download, Flame } from 'lucide-react';
export function Hero() {
  return <section className="pt-8 pb-14 px-4 md:pt-14 md:pb-20 max-w-3xl mx-auto text-center" data-id="element-86">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-87">
        <p className="font-sans font-bold tracking-widest text-gold text-xs uppercase mb-4" data-id="element-88">
          eBookPlanet
        </p>

        {/* BESTSELLER BADGE */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.4,
        delay: 0.1
      }} className="inline-flex items-center gap-1.5 mb-5 rounded-full bg-gold px-4 py-1.5 text-white shadow-md" data-id="element-89">
          <Flame className="w-3.5 h-3.5 fill-current" data-id="element-90" />
          <span className="font-sans text-xs font-bold uppercase tracking-wider" data-id="element-91">
            Bestseller · #1 en amor propio
          </span>
        </motion.div>

        {/* PROMISE — big, bold, dark */}
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-brown-900 font-bold leading-[1.05] mb-6" data-id="element-92">
          No es un libro de frases. Es un sistema para reprogramar tu mente.
        </h1>

        {/* MOCKUP — directly below the title */}
        <motion.div className="flex justify-center mb-6" initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} data-id="element-93">
          <img src="https://cdn.magicpatterns.com/uploads/nzH9GxWSBsfGmcvnNp48mz/MOCKUP_PREMIUM.png" alt="Hackeá tu Realidad — 3 tomos, 6 bonos y 390 páginas" className="w-[70%] max-w-[420px] h-auto drop-shadow-2xl text-[15.7px] font-[Inter,_sans-serif]" loading="eager" data-id="element-94" />
        </motion.div>

        {/* SUBTITLE — smaller, darker, legible */}
        <p className="font-sans md:text-lg text-brown font-medium max-w-xl mx-auto mb-6 text-[15.7px]" data-id="element-95">
          Hackeá tu Realidad reúne todo lo que necesitás para dejar de ser tu
          peor enemigo: las frases que inyectan abundancia y éxito en tu
          subconsciente para que tu vida empiece a sonar de esta manera.
        </p>

        {/* BADGES — above the fold */}
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm font-sans text-brown mb-6 font-semibold" data-id="element-96">
          <span className="flex items-center gap-1" data-id="element-97">
            <Star className="w-4 h-4 text-gold fill-current" data-id="element-98" /> 4.9 / 5
          </span>
          <span className="text-brown/30" data-id="element-99">·</span>
          <span data-id="element-100">+500 lectores</span>
          <span className="text-brown/30" data-id="element-101">·</span>
          <span className="flex items-center gap-1" data-id="element-102">
            <Zap className="w-4 h-4 text-gold" data-id="element-103" /> Acceso inmediato
          </span>
        </div>

        {/* CTA — above the fold */}
        <button onClick={scrollToOffer} className="w-full md:w-auto px-10 py-4 bg-gold hover:bg-gold-600 text-white font-sans font-bold text-lg rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 mb-4" data-id="element-104">
          QUIERO EMPEZAR HOY →
        </button>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs font-sans text-brown/60" data-id="element-105">
          <span className="flex items-center gap-1.5" data-id="element-106">
            <Lock className="w-3.5 h-3.5" data-id="element-107" /> Pago seguro
          </span>
          <span className="hidden sm:inline text-brown/30" data-id="element-108">·</span>
          <span className="flex items-center gap-1.5" data-id="element-109">
            <Download className="w-3.5 h-3.5" data-id="element-110" /> Descarga al instante
          </span>
          <span className="hidden sm:inline text-brown/30" data-id="element-111">·</span>
          <span className="flex items-center gap-1.5" data-id="element-112">
            <Shield className="w-3.5 h-3.5" data-id="element-113" /> Garantía
          </span>
        </div>
      </motion.div>
    </section>;
}